
import { LabOrder } from '../../shared/data/lab-order';
import { LensStyle } from '../../shared/data/lensstyle';
import { ReferenceListItem } from '../../shared/data/reference-list-item';
import { LabOrderBusinessService } from '../../shared/lab-order-business.service';
import { LensStyleApiService } from '../../shared/lens-style.api.service';
import { UtilsService } from '../../shared/utils.service';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { LensService } from './lens.service';

import { Component, OnInit, Input , OnDestroy} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {LensCatalogBusinessService} from '../../shared/lens-catalog-business.service';
import {SubscriptionsContainer} from '../../shared/subscriptions-container';

@Component({
  selector: 'app-lens',
  templateUrl: './lens.component.html',
  styleUrls: ['./lens.component.css']
})
export class LensComponent implements OnInit, OnDestroy {

  // for some reference lists, we don't want the 'none'
  // option added to the drop-downs.
  addNoneOption = false;

  @Input() labOrder: LabOrder;
  materialTypes: ReferenceListItem[];
  visionTypes: ReferenceListItem[];
  tintColors: ReferenceListItem[];
  whichLensBalance: ReferenceListItem[];
  whichLens: ReferenceListItem[];
  lensStyles: LensStyle[];
  subs = new SubscriptionsContainer();

  constructor(
    private labOrderBusinessService: LabOrderBusinessService,
    private lensStyleApiService: LensStyleApiService,
    private lensCatalogBusinessService: LensCatalogBusinessService,
    private formBuilder: FormBuilder,
    private lensService: LensService
  ) { }

  ngOnInit(): void {
    // get Vision Types from Lens Catalog API to populate the Vision Type dropdown
    this.subs.add = this.lensCatalogBusinessService.getVisionTypes()
      .subscribe(
        (data) => {
          console.log('Vision types loaded...', data);
          this.visionTypes = data;
        }
      );

    // get Material Types from Lens Catalog API to populate the Vision Type dropdown
    this.subs.add = this.lensCatalogBusinessService.getMaterialTypes()
      .subscribe(
        (data) => {
          console.log('Material types loaded...', data);
          this.materialTypes = UtilsService.sortObjectArray(data, 'name');
        }
      );

    this.loadLenses();

    // get the reference lists to populate the drop-downs in the bevel section.
    this.subs.add = this.labOrderBusinessService.getReferenceLists()
      .subscribe(
        (data) => {
          this.whichLensBalance = this.labOrderBusinessService.prettifyRefList(data[0],
            this.labOrderBusinessService.getNewEmptyReferenceListItem());
          const whichLensNoneItem: ReferenceListItem = { id: 'NEITHER', name: 'Neither' };
          const whichLensFilterList = ['NEITHER'];
          this.whichLens = this.labOrderBusinessService.prettifyRefList(data[1], whichLensNoneItem, whichLensFilterList);
        },
        (error) => {
          this.materialTypes = null;
          this.visionTypes = null;
          this.whichLensBalance = null;
          this.whichLens = null;
          console.warn('Did not retrieve lens section referencelists');
        }
      );
  }

  ngOnDestroy(): void {
    console.log(' Lens Component - ngOnDestroy ' );
    this.subs.dispose();
  }

  private loadLenses() {
    this.subs.add = this.lensCatalogBusinessService.getLenses(this.labOrder).subscribe(
        (data) => {
          console.log('lenses loaded...', data);
          this.lensStyles = data;
          // insert blank lens style item at top of dropdown.
          this.lensStyles.unshift(this.getBlankLensStyleItem());
        },
        (error) => {
          this.lensStyles = null;
          console.warn('Could not retrieve lenses from the catalog API');
        }
      );
  }

  private getBlankLensStyleItem(): LensStyle {
    const newItem: LensStyle = { id: '', name : '', productDescription: '', externalId: '', visionType: '', materialType: '' };
    return newItem;
  }

  visionTypeUpdated(): void {
    this.lensStyles = null;
    this.labOrder.lens.spectacleLensId = null;
    this.labOrder.lens.spectacleLensDescription = null;
    if (this.labOrder.lens.visionTypeCode) {
      this.loadLenses();
    }
  }

  materialUpdated(): void {
    this.lensStyles = null;
    this.labOrder.lens.spectacleLensId = null;
    this.labOrder.lens.spectacleLensDescription = null;
    if (this.labOrder.lens.materialCode) {
      this.loadLenses();
      this.lensService.setMaterialCode(this.labOrder.lens.materialCode);
    }
  }
}




// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/lens/lens.component.ts